import { render, staticRenderFns } from "./AmountOfMoneyCmp.vue?vue&type=template&id=06127263&"
import script from "./AmountOfMoneyCmp.vue?vue&type=script&lang=js&"
export * from "./AmountOfMoneyCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports